const KEY = "llm-api-key";

let cached: string | null = null;

export function getApiKey(): string | null {
  if (cached !== null) return cached;
  try {
    cached = localStorage.getItem(KEY);
  } catch {
    cached = null;
  }
  return cached;
}

export function setApiKey(key: string): void {
  cached = key;
  try {
    localStorage.setItem(KEY, key);
  } catch {}
}

export function clearApiKey(): void {
  cached = null;
  try {
    localStorage.removeItem(KEY);
  } catch {}
}

export function authHeaders(): Record<string, string> {
  const k = getApiKey();
  return k ? { Authorization: `Bearer ${k}` } : {};
}
